$(function ($) {

    /*---------------- Responsive Menu ------------------*/
    $(".nav-trigger").on('click', function (e) {
        $("body").toggleClass('off-canvas-body');
        $(".menu-bar").toggleClass("off-canvas");
        e.preventDefault();
    });
    if ($(window).width() < 1199) {
        $('.primary-navbar .primary-dropdown > a').on("click", function (e) {
            $(this).next('.primary-dropdown-menu').toggle();
            e.stopPropagation();
            e.preventDefault();
        });
    }

    /*---------------- Best Seller Slider ------------------*/
   
 
    /*---------------- Filter Toggle ------------------*/
      if ($(window).width() < 767) {
        $('.sidebar-content .title').click(function () {
            $(this).toggleClass('open');
            $(this).parent().find('.inner-content').toggle();
        });
    }
  
  /*---------------- Equal Height Div ------------------*/
    var maxHeight = 0;
    $(".prod-title").each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });
    $(".prod-title").height(maxHeight);
  
    /*---------------- Equal Height Div ------------------*/
    var maxcollHeight = 0;
    $(".collection-wrap .title").each(function () {
        if ($(this).height() > maxcollHeight) {
            maxcollHeight = $(this).height();
        }
    });
    $(".collection-wrap .title").height(maxcollHeight);
  
});

